const WhyTuatara = () => {
  return (
    <>
      <div className="custom-container lg:pb-[100] md:pb-[50px] pb-[30px]">
        <div className="flex font-[Rockwell] 2xl:text-[40px] xl:text-[35px] lg:text-[30px] md:text-[25px] sm:text-[20px] text-[17px] font-extrabold ">
          <span className="underline  lg:decoration-[5px] sm:decoration-[4px] decoration-[2px] lg:underline-offset-[24px] md:underline-offset-[18px] sm:underline-offset-[15px] underline-offset-[8px] decoration-[#7ABF5B]">
            WHY TUA
            <span className="underline  lg:decoration-[5px] sm:decoration-[4px] decoration-[2px] lg:underline-offset-[24px] md:underline-offset-[18px] sm:underline-offset-[15px] underline-offset-[8px] !decoration-[#fff]">
              TARA
            </span>
          </span>
        </div>
        <div className="xl:text-[30px] lg:text-[25px] sm:text-[23px] text-[16px] text-[#000] text-[Roboto] font-bold py-[30px]">
          DRIVE THE FUTURE OF UTILITY VEHICLES
        </div>
        <div className="font-[Roboto] 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#000]">
          At Tuatara, we are shaping the next generation of utility vehicles with innovative, sustainable solutions that
          meet the demands of adventurers and professionals alike. Our vehicles are engineered to perform across rugged
          terrains while being easy to maintain and eco-friendly. With a rapidly growing market for electric models, we
          aim to lead the way in the U.S. and beyond.
        </div>
      </div>
    </>
  );
};
export default WhyTuatara;
